// import Nfse from './Index.vue'
import Permissions from "../../models/Permissions";

const Inventarios = () => import("./Index.vue");

const permissions = [
  Permissions.COLABORADOR,
  Permissions.GESTOR,
  Permissions.ADMINISTRADOR,
];

const meta = {
  requiresAuth: true,
  requiresCompany: false,
  showInMenu: true,
  label: "Inventarios",
  icon: "fa fa-files-o",
  group: "Utilitários",
  permissions,
};

export default [
  {
    path: "/inventarios",
    name: "Inventarios",
    component: Inventarios,
    meta,
  },
];
